import React from 'react';

import { useFormContext, useWatch } from 'react-hook-form';

import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';

import {
  EOfferFormatKey,
  IStoreSettingsFormValues
} from '../../../StoreSettings.types';
import {
  ABBREVIATION_SEPARATOR_OPTIONS,
  getAbbreviationDropdownTestId
} from '../AbbreviationsSettingsV2.consts';
import {
  IAbbreviationDropdownField,
  QuantityFieldPath,
  QuantityFieldValue
} from '../AbbreviationsSettingsV2.types';
import { getQuantityFieldPath } from '../AbbreviationsSettingsV2.utils';

interface IQuantityFormatDropdownFieldProps {
  sectionKey: EOfferFormatKey;
  field: IAbbreviationDropdownField;
  onSelect: (path: QuantityFieldPath, value: QuantityFieldValue) => void;
}

export const QuantityFormatDropdownField = ({
  sectionKey,
  field,
  onSelect
}: IQuantityFormatDropdownFieldProps): React.ReactElement => {
  const { control } = useFormContext<IStoreSettingsFormValues>();
  const fieldPath = getQuantityFieldPath(sectionKey, field.key);
  const rawValue = useWatch({ control, name: fieldPath });

  const selectedValue = String(rawValue);
  const defaultSelected = ABBREVIATION_SEPARATOR_OPTIONS.find(
    (option) => option.value === selectedValue
  );

  const handleOptionChange = (value: string): void => {
    onSelect(fieldPath, value);
  };

  return (
    <InputSelectDropdown
      label={field.label}
      options={ABBREVIATION_SEPARATOR_OPTIONS}
      defaultSelected={defaultSelected}
      onOptionChange={handleOptionChange}
      shouldCapitalizeOptions={false}
      dataTestId={getAbbreviationDropdownTestId(field.key)}
    />
  );
};
